import React from 'react';
import { MiniArrowIcon } from '@components/icons/mini-arrow-icon';
import { LanguageSelector } from '@components/organisms/language-selector';
import type { MobileHeaderProps } from '@modules/dashboard/pages/kyc/docs-verification/docs-verification-page/mobile-header/types';
import cn from 'classnames';

import { Container, Header } from './styles';

export const MobileHeader: React.FC<MobileHeaderProps> = ({
    onBack,
    title,
    className,
    isFixed,
}) => (
    <Container>
        <LanguageSelector className='language-selector' />
        <Header className={cn('header-mobile-container', { 'fixed-header': isFixed }, className)}>
            <MiniArrowIcon className='mobile-header-back-icon' onClick={onBack} />
            <span className='inner-title' dangerouslySetInnerHTML={{ __html: title }} />
        </Header>
    </Container>
);
